import {Component, Input} from '@angular/core';

import {PublicAdDetailResponse} from "@numizmat/services-models/core";

@Component({
    selector: 'nz-description-section',
    imports: [],
    templateUrl: './description-section.component.html',
    styleUrl: './description-section.component.scss'
})
export class DescriptionSectionComponent {
  @Input() adDetails!: PublicAdDetailResponse;
}
